<template>
    <div class="quick-links" :class="[quickcontiner ? 'isopen' : '']" id="quiklinkid">
        <div class="quick-links-container">
            <div  class="quick-links-container__list"> 
                <a v-hrefsafe="item.CTALink.Url" @click="tagging(item)" :target="item.CTALink.Target" class="quick-links-container__list--items" v-for="(item,i) in quickLinks.QuickLinks" :key="i">
                    <div class="quick-links-container__list--items_title" v-htmlsafe="item.CTALabel"></div>
                    <img class="lazy quickimage" src="data:image/gif;base64,R0lGODlhAQABAAAAACH5BAEKAAEALAAAAAABAAEAAAICTAEAOw=="  :data-src="item.Image.Src" :alt="item.Image.Alt" >
                </a>
            </div> 
            <div class="quick-links-container__button" @click="open()">
                <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M16 6L16 26" stroke="white" stroke-width="3"/>
                    <path d="M26 16L6 16" stroke="white" stroke-width="3"/>
                </svg>
            </div>
        </div>
    </div>
</template>
<script>
export default {
    name:"quick-link",
    data() {
        return  {
            quickcontiner: false
        }
    },
    props: { 
        quickLinks: {type: Object, default: () => {} }
    },
    mounted() {
        if(this.quickLinks.isdefaultOpen) {
            this.open();
        }
    },
    methods:{
        open() {
            this.quickcontiner = !this.quickcontiner;
            let img = document.getElementsByClassName('quickimage');
            let container = document.getElementById("quiklinkid");
            if(this.quickcontiner) { 
                let height = (this.quickLinks.QuickLinks.length * 68) + 58;
                container.style.height = height+'px';
            }else {
                container.style.height = 0 +'px';
            }
           
        },
        tagging(data) {
            let taggingData ={ 
                'event':'uaevent',
                'event_name':'body_button_click',	
                'ecommerce': 'undefined',
                'cta_name':	`${data.CTALabel.replace(/<\/?[^>]+(>|$)/g, '').toLowerCase()}`,
                'link_url': window.location.origin + data.CTALink.Url,
                'module_name':this.quickLinks.isdefaultOpen ? 'quick links displayed' :'quick links opened'
            }
            window.dataLayer.push(taggingData);
        }
    }
}
</script>
<style lang="scss" src="./quick-link.scss"></style>